import React from 'react';
import { createDevTools } from 'redux-devtools';
import LogMonitor from 'redux-devtools-log-monitor';
import DockMonitor from 'redux-devtools-dock-monitor';

// Configure redux devtools
const DevTools = createDevTools(
  <DockMonitor
    defaultSize={0.15}
    toggleVisibilityKey='ctrl-h'
    changePositionKey='ctrl-m'>
    <LogMonitor />
  </DockMonitor>
);

export default DevTools;



// WEBPACK FOOTER //
// ./shared/redux/DevTools/index.js